const signalR = require("@microsoft/signalr");
var connection = new signalR.HubConnectionBuilder().withUrl("/conexionHub").build();
export default connection;
